import React from 'react'

export default function Document() {
    return (
        <div>
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M81.25 37.5H56.25V12.5H18.75V87.5H81.25V37.5ZM78.6625 31.25L62.5 15.0875V31.25H78.6625ZM15.625 6.25H62.5L87.5 31.25V90.625C87.5 91.4538 87.1708 92.2487 86.5847 92.8347C85.9987 93.4208 85.2038 93.75 84.375 93.75H15.625C14.7962 93.75 14.0013 93.4208 13.4153 92.8347C12.8292 92.2487 12.5 91.4538 12.5 90.625V9.375C12.5 8.5462 12.8292 7.75134 13.4153 7.16529C14.0013 6.57924 14.7962 6.25 15.625 6.25ZM31.25 50H68.75V56.25H31.25V50ZM31.25 31.25H46.875V37.5H31.25V31.25ZM31.25 68.75H68.75V75H31.25V68.75Z" fill="#BB0600" />
            </svg>

        </div>
    )
}
